__turbopack_context__.v({
  "button": "DeliveryMethodModal-module-scss-module__ylUM5G__button",
  "heading": "DeliveryMethodModal-module-scss-module__ylUM5G__heading",
  "mainText": "DeliveryMethodModal-module-scss-module__ylUM5G__mainText",
  "modal": "DeliveryMethodModal-module-scss-module__ylUM5G__modal",
  "subHeading": "DeliveryMethodModal-module-scss-module__ylUM5G__subHeading",
});
